module.exports = __webpack_public_path__ + "img/11.8ffa051e.png";